<template>
  <header class="bg-hero">
    <Container
      :class="{
        'py-24 md:py-56 lg:py-64 xl:py-80': !teaserImage,
        'flex max-w-screen-xl flex-col gap-48 py-64 md:grid md:grid-flow-row md:grid-cols-2 md:gap-64 md:py-144 xl:gap-96':
          teaserImage,
      }"
    >
      <MediaImage
        v-bind="teaserImage"
        :image-style="imageStyle"
        img-class="w-full rounded-large"
        class="col-span-1"
      />
      <div class="col-span-1 md:flex md:flex-col md:justify-center">
        <slot />

        <p
          v-if="tagline"
          v-blokkli-editable:field_lead_title
          class="mb-8 text-lg font-regular text-blue-900"
          :class="{ 'text-white': inverted }"
        >
          {{ tagline }}
        </p>
        <h1
          v-if="title"
          v-blokkli-editable:title
          class="typo-h1 text-pretty font-semibold tracking-wide text-blue-900"
          :class="{ 'text-white': inverted }"
        >
          {{ title }}
        </h1>
        <p
          v-if="lead"
          v-blokkli-editable:field_intro
          class="typo-lead-1 mt-20 text-pretty font-regular leading-snug text-blue-900"
          :class="{ 'text-white': inverted }"
          v-html="lead"
        />
      </div>
    </Container>
  </header>
</template>

<script setup lang="ts">
import type { MediaImageFragment } from '#graphql-operations'

defineProps<{
  title?: string
  tagline?: string
  lead?: string
  inverted?: boolean
  teaserImage?: MediaImageFragment
}>()

defineOptions({
  name: 'PageHeader',
})

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    xs: 480,
    lg: 640,
  },
})
</script>
